import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';
import {MISC_FEE_FREQUENCY} from '../../../constants/Lookup';

const initialData = {
  advanceSearchData: {},
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};
const slice = createSlice({
  name: 'SeparateStatementsSettings',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, fetchDropDownData, fetchError} = slice.actions;
export const fetchDropdown = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [MISC_FEE_FREQUENCY],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
